module.exports = __webpack_public_path__ + "static/media/Nunito-Bold.f14bc25a.ttf";